import { render, staticRenderFns } from "./protocolo.vue?vue&type=template&id=262efbe9&"
import script from "./protocolo.vue?vue&type=script&lang=js&"
export * from "./protocolo.vue?vue&type=script&lang=js&"
import style0 from "./protocolo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports